import {
  initializeFaro,
  getWebInstrumentations,
  type Faro
} from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const collectorUrl = config.public.faroCollectorUrl as string | undefined

  if (!collectorUrl) return

  const faro: Faro = initializeFaro({
    url: collectorUrl,
    app: {
      name: 'una-su-app',
      version: (config.public.appVersion as string) || '1.0.0',
      environment: (config.public.nodeEnv as string) || 'production'
    },
    instrumentations: [
      ...getWebInstrumentations({ captureConsole: false }),
      new TracingInstrumentation()
    ]
  })

  const user = useSupabaseUser()
  watch(
    user,
    (u) => {
      if (u) {
        faro.api.setUser({ id: u.id, email: u.email ?? undefined })
      } else {
        faro.api.resetUser()
      }
    },
    { immediate: true }
  )
})
